import { useRef } from 'react'

import { addOnTryAgainToAction } from '../../actions/error/onTryAgain'
import ClientModule from '../../modules/client/Module'

import { ISessionUseNavigationButtonState } from '../types'
import { ActionType } from '../../actions/types'

const useNextButtonState: ISessionUseNavigationButtonState = (
  currentActionState,
  currentActionComponentRef,
  navigationState,
  _screenNumberState,
  mountedRef
) => {
  const onNextRef = useRef<() => void>(null)
  if (null == onNextRef.current) {
    onNextRef.current = () => {
      if (navigationState.navigationRef.current?.nextEnabled) {
        // speed click lock
        navigationState.navigationRef.current.enableNext(false)
        if (currentActionComponentRef.current && !currentActionComponentRef.current.tryNext()) {
          const doSubmitResponse = async (
            submitAction = currentActionState.currentActionRef.current,
            submitResponse = currentActionComponentRef.current.submitResponse
          ) => {
            if (mountedRef.current) {
              navigationState.navigationRef.current.preNext()
            }
            // send submit response
            const nextAction = await ClientModule.sendResponse(submitAction, submitResponse)
            if (nextAction) {
              if (ActionType.ERROR === nextAction.action) {
                addOnTryAgainToAction(nextAction, () => {
                  void doSubmitResponse(submitAction, submitResponse)
                })
              }
              if (mountedRef.current) {
                currentActionState.setCurrentAction(nextAction)
                navigationState.navigationRef.current.postNext()
              }
            }
          }
          void doSubmitResponse()
        }
      } else if (currentActionComponentRef.current) {
        currentActionComponentRef.current.showValidation()
      }
    }
  }

  return { onActionRef: onNextRef } as const
}

export default useNextButtonState
